import IsaasImporter from "./IsaasImporter.js";
import TwinfieldIsaasIntegration from "../../../../models/integration/TwinfieldIsaasIntegration.js";

/**
 * `TwinfieldIsaasImporter` Import wizard for the Twinfield integration using iSaaS.
 */
export default class TwinfieldIsaasImporter extends IsaasImporter {
	_getConnectorType() {
		return "twinfield";
	}

	_wantExtendedActionsInConfigureImportDataStep() {
		return false;
	}
}

TwinfieldIsaasImporter.integrationType = TwinfieldIsaasIntegration.getType();
